import React from 'react';
import { TmntHtml, TmntText } from '../Common';
import { textProp } from '../../tools/customProps';

export default function InvalidOrderErrorPage({ title, content }) {
  return (
    <section className="module-section not-valid-order invalid-order_error" data-testid="invalid-order-error">
      <div className="module-section-header">
        <TmntText tmnt={title} />
      </div>
      <div className="module-section-content">
        <TmntHtml tmnt={content} />
      </div>
    </section>
  );
}

InvalidOrderErrorPage.propTypes = {
  title: textProp,
  content: textProp,
};

InvalidOrderErrorPage.defaultProps = {
  title: '',
  content: '',
};
